import CoaScreen from './coa';

import TransactionScreen from './transaction';
import TransactionCreateScreen from './transaction/create';
import TransactionUpdateScreen from './transaction/update';

import JournalScreen from './journal';
import JournalCreateScreen from './journal/create';
import JournalUpdateScreen from './journal/update';

import LedgerScreen from './ledger';
import BalanceSheetScreen from './balancesheet';
import ProfitAndLossScreen from './profitandloss';

import ClosingScreen from './closing';
import ClosingDetailScreen from './closing/detail';

const routes = [
  // coa
  {
    path: '/accounting/coa',
    component: CoaScreen,
  },
  // transaction
  {
    path: '/accounting/transaction',
    component: TransactionScreen,
  },
  {
    path: '/accounting/transaction/create',
    component: TransactionCreateScreen,
  },
  {
    path: '/accounting/transaction/update/:id',
    component: TransactionUpdateScreen,
  },
  // journal
  {
    path: '/accounting/journal',
    component: JournalScreen,
  },
  {
    path: '/accounting/journal/create',
    component: JournalCreateScreen,
  },
  {
    path: '/accounting/journal/update/:id',
    component: JournalUpdateScreen,
  },
  // ledger
  {
    path: '/accounting/ledger',
    component: LedgerScreen,
  },
  // balance sheet
  {
    path: '/accounting/balancesheet',
    component: BalanceSheetScreen,
  },
  // profitandloss
  {
    path: '/accounting/profitandloss',
    component: ProfitAndLossScreen,
  },
  // closing
  {
    path: '/accounting/closing',
    component: ClosingScreen,
  },
  {
    path: '/accounting/closing/:id',
    component: ClosingDetailScreen,
  },
];

export default routes;
